import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useEffect, useRef } from "react";
import { useWindowSize } from "react-use";
gsap.registerPlugin(ScrollTrigger);
const Mediasection = ({
  imgSrc,
  leftMediaText,
  rightMediaText,
  reverse,
  customCSs,
}) => {
  const { width } = useWindowSize();
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const boxRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add("(min-width: 992px)", () => {
        gsap.fromTo(
          leftRef?.current,
          {
            xPercent: "65",
          },
          {
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: leftRef?.current,
              // markers: true,
              start: "top 60%",
              end: "top 25%",
              scrub: 2,
            },
          }
        );

        gsap.fromTo(
          rightRef?.current,
          {
            opacity: 0,
            xPercent: "-50",
          },
          {
            delay: 0.5,
            opacity: 1,
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: rightRef?.current,
              // markers: true,
              start: "top 55%",
              end: "top 25%",
              scrub: 2,
            },
          }
        );
      });

      mm.add("(min-width: 768px) and (max-width: 991px)", () => {
        gsap.fromTo(
          leftRef?.current,
          {
            xPercent: "70",
          },
          {
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: leftRef?.current,
              // markers: true,
              start: "top 45%",
              end: "top 40%",
              scrub: 2,
            },
          }
        );

        gsap.fromTo(
          rightRef?.current,
          {
            opacity: 0,
            xPercent: "-50",
          },
          {
            delay: 0.5,
            opacity: 1,
            duration: 1,
            xPercent: 0,
            scrollTrigger: {
              trigger: rightRef?.current,
              // markers: true,
              start: "top 40%",
              end: "top 40%",
              scrub: 2,
            },
          }
        );
      });

      return () => mm.revert();
    },
    [],
    { scope: boxRef.current }
  );

  return (
    <div
      className={`w-full lg:pr-[16.30vw] md:pl-[11.67vw] 2xl:pr-[13rem] relative ${customCSs}`}
    >
      <div
        data-aos={width > 768 ? "" : "fade-up"}
        ref={boxRef}
        className={` w-full  flex flex-col md:flex-row   justify-center px-[4vh] relative  ${
          reverse ? "flex-row-reverse" : "flex-row"
        }`}
      >
        {/* Left side */}
        <div
          ref={leftRef}
          className="left z-10 md:w-[32.08vw] w-[91.47vw] w-full flex flex-col p-6 items-center justify-center bg-glass/30 backdrop-blur-3xl"
        >
          <div className="">
            <div className="flex items-center justify-center">
              <img
                src={imgSrc}
                alt=""
                className=" md:w-[5.36vw] w-[21.33vw] object-contain p-2"
              />
            </div>
            <p className="w-[90vw] w-full lg:w-[18.22vw] h-auto  text-center text-transparent bg-clip-text bg-text-gradient font-bebas_neue md:text-[2.08vw] text-[8.53vw] tracking-normal md:leading-[2.50vw]  leading-[10.67vw]">
              {leftMediaText}
            </p>
          </div>
        </div>

        <div
          ref={rightRef}
          className="right px-[24px] md:px-12 py-[32px] w-[91.47vw] w-full h-auto sm:min-h-[152px] md:w-[39.96vw] md:h-[14.46vw] flex flex-col  justify-center md:py-4 border-[1px] border-gray-100 border-solid border-opacity-30"
        >
          <p className="text-left font-light md:text-[1.15vw] text-[5.33vw]  tracking-normal font-montserrat text-gray-100   overflow-hidden">
            {rightMediaText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mediasection;
